export var formatCurrency = function formatCurrency(num) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  var currency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'USD';
  var minimumFractionDigits = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;

  if (isNaN(num)) {
    return num;
  }

  return num.toLocaleString(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: minimumFractionDigits
  });
};